import React from 'react';
import SearchService from '../classes/SearchService';

import getExternalLink from '../functions/getExternalLink';

const searchService = new SearchService();

export default class Bike360 {

    constructor(bike, color = 'blackblue') {
        this.folder = bike.folder;
        this.colors = bike.colors;
        this.wheel = bike.wheel;
        this.color = color;
        this.type = bike.type;
        this.startImgIndex = 5;
    }

    getImages(key = 'desktop') {

        let selectedColor = this.colors.filter((color) => color === this.color)[0];

        let arrBeforeStart = [], arrAfterStart = [];

        const createImgArray = (index) => {

            const imgSRC = `i/${this.folder}/${this.wheel}/${this.type}/${selectedColor ? selectedColor : this.colors[0]}/${index}.jpg`;
            const image = <img key={index} src={imgSRC} width="512" height="512" alt="bike" />;

            index < this.startImgIndex
                ? arrBeforeStart.push(image)
                : arrAfterStart.push(image)  

        }

        for (let i = 1; i <= 36; i++) {

            if (key === "mobile") {
                if (i % 3 === 0 || i === this.startImgIndex) { createImgArray(i) }
            } else { createImgArray(i) }
            
        }

        const imgArray = arrAfterStart.concat(arrBeforeStart);

        return imgArray;

    }

    getMobileImage() {

        let selectedColor = this.colors.filter((color) => color === this.color)[0];

        return (index = this.startImgIndex) => `i/${this.folder}/${this.wheel}/${this.type}/${selectedColor ? selectedColor : this.colors[0]}/${index}.jpg`;

    }

    getAllStartImgs() {

        const firstBikes = searchService.getFirstImages();      

        return firstBikes.map((bike, index) => {
            const imgSRC = `i/${bike.folder}/${bike.wheel}/${bike.type}/${bike.color}/${this.startImgIndex}.jpg`;
            return <img key={index} src={imgSRC} alt="bike" width='512' height='512' />

        })

    }

    getGlobalSRC() {

        const externalLink = getExternalLink();

        let selectedColor = this.colors.filter((color) => color === this.color)[0];
        return `${externalLink}/i/${this.folder}/${this.wheel}/${this.type}/${selectedColor ? selectedColor : this.colors[0]}/${this.startImgIndex}.jpg`;

    }

}


// WEBPACK FOOTER //
// ./src/classes/Bike360.js